import { render } from "./DowntimesStatisticsPage.vue?vue&type=template&id=577ab1d0&scoped=true"
import script from "./DowntimesStatisticsPage.vue?vue&type=script&lang=js"
export * from "./DowntimesStatisticsPage.vue?vue&type=script&lang=js"

import "./DowntimesStatisticsPage.vue?vue&type=style&index=0&id=577ab1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577ab1d0"]])

export default __exports__